import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { CTAButton } from 'shared-components/buttons/cta-button';

const CTABanner = ({
  icon,
  header,
  body,
  buttonText,
  onClickAction,
  alertState,
  headerNotBold,
  isDisabled = false
}) => {
  return (
    <div className={classnames('CTABanner col-xs-12 flex column-sm border margin-xl-bottom', { alert: alertState })}>
      <div className={classnames('flex', { column: !!body })}>
        <div className={classnames('flex middle', { 'margin-md-bottom': !!body })}>
          { icon &&
              <img className="icon margin-md-right" src={`https://assets.peerspace.com/${icon}.svg?v=rb`} alt={icon} />
          }
          <span className={headerNotBold ? 'text-gray-600' : 'heavy'}>{header}</span>
        </div>

        <div className="margin-xl-right text-gray-600">
          {body}
        </div>
      </div>
      {
        buttonText && onClickAction &&
          <div className="flex middle block-md-left">
            <CTAButton
              buttonText={buttonText}
              classNameString={classnames('btn', { 'btn-primary': alertState, 'btn-gray-outline btn-outlined-light': !alertState })}
              onClickAction={onClickAction}
              isDisabled={ isDisabled }
            />
          </div>
      }
    </div>
  );
};

CTABanner.propTypes = {
  bannerObject: PropTypes.object,
  icon: PropTypes.string,
  onClickAction: PropTypes.func,
  alertState: PropTypes.bool,
  headerIsBold: PropTypes.bool,
  isDisabled: PropTypes.bool
};

export default CTABanner;
